import React, { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
// sostituito il layout a tabella con una griglia per mostrare 2 colonne
import { Button } from "@/components/ui/button";
import { useThemeConfig } from "@/components/ui/theme-config-provider";
interface SimpleCategory {
  id: string;
  name: string;
  icon: string;
  /**
   * Colore di sfondo della categoria
   */
  color: string;
  /**
   * Colore del testo da usare sullo sfondo della categoria
   */
  textColor?: string;
}

interface CategoryPickerDialogProps {
  open: boolean;
  categories: SimpleCategory[];
  selectedId?: string;
  onSelect: (categoryId: string) => void;
  onOpenChange: (open: boolean) => void;
}

const CategoryPickerDialog = ({ open, categories, selectedId, onSelect, onOpenChange }: CategoryPickerDialogProps) => {
  const [current, setCurrent] = useState<string | undefined>(selectedId);
  const { theme } = useThemeConfig();

  // Mantiene allineata la selezione alla prop esterna
  useEffect(() => {
    setCurrent(selectedId);
  }, [selectedId, open]);

  const handleSelect = () => {
    if (current) {
      onSelect(current);
    }
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="max-w-full"
        style={{
          backgroundColor: theme.cardBackgroundColor,
          borderRadius: theme.cardBorderRadius,
          borderColor: theme.borderColor,
          color: theme.textColor,
        }}
      >
        <DialogHeader>
          <DialogTitle>Seleziona categoria<br/><br/></DialogTitle>
        </DialogHeader>
        <div className="max-h-80 overflow-y-auto">
          <div className="grid grid-cols-2 gap-2">
            {categories.map((cat) => (
              <button
                key={cat.id}
                type="button"
                className="w-full flex items-center gap-2 rounded-md px-2 py-1 focus:outline-none active:bg-transparent"
                style={{
                  // Mantiene l'arancione per la categoria selezionata, altrimenti usa il colore della categoria
                  backgroundColor:
                    current === cat.id ? theme.primaryColor : cat.color,
                  // Testo bianco sull'arancione selezionato, altrimenti colore del testo della categoria
                  color:
                    current === cat.id
                      ? theme.textPrimaryColor
                      : cat.textColor || theme.primaryColor,
                  borderRadius: theme.buttonBorderRadius,
                }}
                onClick={() => setCurrent(cat.id)}
              >
                <span>{cat.icon}</span>
                <span>{cat.name}</span>
              </button>
            ))}
          </div>
        </div>
        <DialogFooter className="mt-4 flex flex-row justify-between sm:justify-between sm:space-x-0">
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
            style={{
              backgroundColor: theme.backgroundColor,
              color: theme.textColor,
              borderRadius: theme.buttonBorderRadius,
              padding: theme.buttonPadding,
              fontWeight: theme.buttonFontWeight,
              transitionDuration: theme.transitionSpeed,
              borderColor: theme.borderColor,
            }}
          >
            Annulla
          </Button>
          <Button
            onClick={handleSelect}
            disabled={!current}
            className="hover:bg-[var(--btn-bg-hover)]"
            style={{
              backgroundColor: theme.primaryColor,
              color: theme.textPrimaryColor,
              borderRadius: theme.buttonBorderRadius,
              padding: theme.buttonPadding,
              fontWeight: theme.buttonFontWeight,
              transitionDuration: theme.transitionSpeed,
              // @ts-ignore custom css var
              '--btn-bg-hover': theme.primaryColor,
            }}
          >
            Seleziona
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default CategoryPickerDialog;
